import { Link } from 'react-router-dom';
import { platformStats } from '@/mocks/site';

function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20and%20rose%20gradient%20scene%20with%20soft%20floating%20paper%20textures%20and%20glowing%20bokeh%20particles%2C%20editorial%20magazine%20cover%20background%2C%20cinematic%20lighting%2C%20deep%20warm%20shadows%2C%20no%20text%2C%20rich%20layered%20composition&width=1920&height=1080&seq=hero-chigua-main-01&orientation=landscape"
          alt="网报吃瓜热点快讯聚合平台首屏背景"
          title="网报吃瓜 - 热点快讯聚合"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80" />
      </div>

      <div className="relative w-full px-4 md:px-8 pb-14 pt-28 md:pb-20 md:pt-40">
        <div className="mx-auto max-w-4xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 md:text-sm">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-400" />
            </span>
            快讯实时更新中 · 每日 08:00 - 24:00
          </span>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-[1.25] text-background-50 md:text-5xl md:leading-[1.2]">
            网报吃瓜快讯实时刷不停
            <br className="hidden md:block" />
            媒体报道与转载全程跟踪
          </h1>

          <p className="mt-5 text-sm leading-relaxed text-background-200/90 md:text-base">
            点开即见网报吃瓜媒体、媒体报道、快讯与转载的聚合视角，省去在多个网页之间反复切换。
            所有热点按时间线排列，事件起因、扩散路径与各方报道差异一次看清。
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/feed"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-400 sm:w-auto"
            >
              <i className="ri-flashlight-fill" />
              进入快讯时间线
            </Link>
            <Link
              to="/topics"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-route-line" />
              浏览热点专题
            </Link>
          </div>
        </div>

        <div className="mx-auto mt-12 grid max-w-4xl grid-cols-2 gap-4 border-t border-background-50/15 pt-8 md:mt-16 md:grid-cols-4 md:gap-6">
          {platformStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="flex items-center justify-center gap-1.5 font-heading text-xl font-bold text-primary-300 md:text-2xl">
                <i className={stat.icon} />
                {stat.value}
              </div>
              <div className="mt-1.5 text-xs text-background-200/80 md:text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;